/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var $btnZipcode = $(".btn-zipcode");
  var $form = $(".form-container");
  var $btnSubmit = $(".form-container button[type='submit']")
  var $wellWarning = $(".well-warning");

  $('label input[type="radio"]').on('click', function () {
    $('input[name="' + this.name + '"]').each(function () {
      $(this.parentNode).toggleClass('active', this.checked);
    });
  });

  $btnZipcode.attr('disabled', true);

  $(".zipcode").keyup(function () {
    if ($(this).val().length != 0)
      $btnZipcode.attr('disabled', false);
    else
      $btnZipcode.attr('disabled', true);
  });

  $wellWarning.hide();

  function hasPhoneNum() {
    var targetElement = $form.find('input[name*="固定電話"]');
    var phoneNum = "";

    targetElement.each(function(index, element) {
      if(Number(element.value) > 0) {
        phoneNum += element.value;
      }else {
        phoneNum += 'x';
      }
    });
    phoneNum = new Boolean(Number(phoneNum));

    if(phoneNum > 0) {
      $form.find('input[name*="携帯電話"]').removeAttr('required');
    }else {
      console.log('false!!!!')
      $form.find('input[name*="携帯電話"]').eq(0).attr('required');
    }
  }

  function hasMobilePhoneNum() {
    var targetElement = $form.find('input[name*="携帯電話"]');
    var mobilePhoneNum = "";

    targetElement.each(function(index, element) {
      if(Number(element.value) > 0) {
        mobilePhoneNum += element.value;
      }else {
        mobilePhoneNum += 'x';
      }
    });
    mobilePhoneNum = new Boolean(Number(mobilePhoneNum));

    if(mobilePhoneNum > 0) {
      $form.find('input[name*="固定電話"]').removeAttr('required');
    }else {
      console.log('false!!!!')
      $form.find('input[name*="固定電話"]').attr('required');
    }
  }

  $btnSubmit.on('click', function (event) {
    hasPhoneNum();
    hasMobilePhoneNum();

    if ($form.valid() == false) {
      $wellWarning.slideDown("fast");
    }
  });
});
